import React from 'react';
import { LayoutDashboard, UserCircle, CreditCard, History, Settings, Wifi, LogOut, Plus, Zap } from 'lucide-react';
import { Button } from '../Button';
const sidebarLinks = [{
  icon: LayoutDashboard,
  label: 'Dashboard',
  href: '/dashboard'
}, {
  icon: UserCircle,
  label: 'Profile',
  href: '/dashboard/profile'
}, {
  icon: Wifi,
  label: 'My eSIMs',
  href: '/dashboard/esims'
}, {
  icon: History,
  label: 'Usage History',
  href: '/dashboard/usage'
}, {
  icon: CreditCard,
  label: 'Transactions',
  href: '/dashboard/transactions'
}, {
  icon: Settings,
  label: 'Settings',
  href: '/dashboard/settings'
}];
export function DashboardLayout({
  children,
  onRechargeClick
}: {
  children: React.ReactNode;
  onRechargeClick?: () => void;
}) {
  return <div className="min-h-screen bg-gray-50" data-id="element-187">
      {/* Sidebar */}
      <aside className="fixed left-0 top-0 h-screen w-64 bg-white border-r border-gray-200 z-40" data-id="element-188">
        <div className="flex flex-col h-full" data-id="element-189">
          {/* Logo */}
          <div className="p-6 border-b border-gray-200" data-id="element-190">
            <div className="flex items-center" data-id="element-191">
              <div className="h-8 w-8 rounded-full bg-[#2563EB] flex items-center justify-center mr-2" data-id="element-192">
                <Wifi className="h-4 w-4 text-white" data-id="element-193" />
              </div>
              <span className="text-lg font-bold" data-id="element-194">TravelSIM</span>
            </div>
          </div>
          {/* Quick Actions */}
          <div className="p-4" data-id="element-195">
            <div className="space-y-2" data-id="element-196">
              <Button variant="primary" fullWidth data-id="element-197">
                <Plus className="h-4 w-4 mr-2" data-id="element-198" />
                Buy New eSIM
              </Button>
              <Button variant="secondary" fullWidth onClick={onRechargeClick} data-id="element-199">
                <Zap className="h-4 w-4 mr-2" data-id="element-200" />
                Recharge & Upgrade
              </Button>
            </div>
          </div>
          {/* Navigation */}
          <nav className="flex-1 px-4 py-4 space-y-1" data-id="element-201">
            {sidebarLinks.map(link => <a key={link.href} href={link.href} className="flex items-center px-4 py-3 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-202">
                <link.icon className="h-5 w-5 mr-3" data-id="element-203" />
                {link.label}
              </a>)}
          </nav>
          {/* User section */}
          <div className="p-4 border-t border-gray-200" data-id="element-204">
            <div className="flex items-center mb-4" data-id="element-205">
              <div className="h-10 w-10 rounded-full bg-gray-200 mr-3" data-id="element-206"></div>
              <div data-id="element-207">
                <p className="font-medium" data-id="element-208">John Doe</p>
                <p className="text-sm text-gray-500" data-id="element-209">john@example.com</p>
              </div>
            </div>
            <Button variant="outline" fullWidth data-id="element-210">
              <LogOut className="h-4 w-4 mr-2" data-id="element-211" />
              Sign Out
            </Button>
          </div>
        </div>
      </aside>
      {/* Main content */}
      <main className="ml-64 p-8" data-id="element-212">{children}</main>
    </div>;
}